import PresentationCard from "../Components/Cards/PresentationCard";
import Wheels from "../Assets/Wheels.png";
import Rollers from "../Assets/Rollers.png";
import Accessories from "../Assets/Accessories.png";
import Delivery from "../Assets/Delivery.jpg";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import React, { useEffect } from "react";

const HomeCards: React.FC = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-evenly"
      alignItems="stretch"
      spacing={{ xs: 2, md: 3 }}
      columns={{ xs: 1, sm: 2, md: 4, lg: 6 }}
    >
      <Grid item xs={1} sm={1} md={2} lg={2} >
        <PresentationCard
          img={Wheels}
          title={t("common.wheels")}
          detail={t("presentation.wheels.card")}
          guide_link="Wheels/Guide"
          buy_link="Wheels"
        ></PresentationCard>
      </Grid>
      <Grid item xs={1} sm={1} md={2} lg={2}>
        <PresentationCard
          img={Rollers}
          title={t("common.rollers")}
          detail={t("presentation.rollers.card")}
          guide_link="Rollers/Guide"
          buy_link="Rollers"
        ></PresentationCard>
      </Grid>
      <Grid item xs={1} sm={2} md={4} lg={2}>
        <PresentationCard
          img={Accessories}
          title={t("common.accessories")}
          detail={t("presentation.accessories.card")}
          guide_link="Accessories/Guide"
          buy_link="Accessories"
        ></PresentationCard>
      </Grid>
      <Grid item xs={1} sm={2} md={4} lg={6} display={"flex"}>
      <PresentationCard
          img={Delivery}
          title={t("common.delivery")}
          detail={t("presentation.delivery")}
          ></PresentationCard>
      </Grid>
    </Grid>
  );
};

export default React.memo(HomeCards);
